import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
// @ts-ignore
import sogardAvatar from '~/features/chatbot/assets/sogard-avatar.png';

interface ChatbotEntryPointProps {
    onClick: () => void;
    isActive?: boolean;
}

const ChatbotEntryPoint = ({ onClick, isActive }: ChatbotEntryPointProps) => {
    const intl = useIntl();
    const [showBubble, setShowBubble] = useState(false);
    const [bubbleDismissed, setBubbleDismissed] = useState(false);

    useEffect(() => {
        if (isActive || bubbleDismissed) {
            setShowBubble(false);
            return;
        }

        const timer = setTimeout(() => {
            setShowBubble(true);
        }, 2000);

        return () => clearTimeout(timer);
    }, [isActive, bubbleDismissed]);

    const handleClick = () => {
        setShowBubble(false);
        setBubbleDismissed(true);
        onClick();
    };

    const handleDismissBubble = (e: React.MouseEvent | React.KeyboardEvent) => {
        e.stopPropagation();
        setShowBubble(false);
        setBubbleDismissed(true);
    };

    const bubbleText = intl.formatMessage({ id: 'intl-msg:chatbot.entryPoint.bubble' });
    const ariaLabel = intl.formatMessage({ id: 'intl-msg:chatbot.entryPoint.ariaLabel' });
    const dismissLabel = intl.formatMessage({ id: 'intl-msg:chatbot.entryPoint.dismissBubble' });

    return (
        <div
            className="position-fixed display-flex align-items-center gap-10"
            style={{ bottom: '24px', right: '24px', zIndex: 1500 }}
            data-testid="chatbot-entry-point-container"
        >
            {showBubble && !isActive && (
                <div
                    className="display-flex align-items-center gap-10 padding-10 padding-left-20 padding-right-15 text-color-white cursor-pointer text-size-14"
                    style={{
                        backgroundColor: '#9b2d6b',
                        borderRadius: '24px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        whiteSpace: 'nowrap',
                    }}
                    onClick={handleClick}
                    role="button"
                    tabIndex={0}
                    data-testid="chatbot-bubble-message"
                >
                    <span>{bubbleText}</span>
                    <span
                        className="uikit-icon icon-remove text-color-white text-size-14 cursor-pointer"
                        onClick={handleDismissBubble}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                handleDismissBubble(e);
                            }
                        }}
                        role="button"
                        tabIndex={0}
                        aria-label={dismissLabel}
                        data-testid="chatbot-bubble-dismiss"
                    />
                </div>
            )}

            <button
                className="btn position-relative display-flex align-items-center justify-content-center"
                style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '50%',
                    padding: '0',
                    border: 'transparent',
                    overflow: 'hidden',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    background: 'white',
                }}
                onClick={handleClick}
                data-testid="chatbot-entry-point"
                aria-label={ariaLabel}
            >
                {isActive ? (
                    <span className="uikit-icon icon-remove text-size-20 text-color-darkest" aria-hidden="true" />
                ) : (
                    <img
                        src={sogardAvatar}
                        alt="Sogard"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                )}
            </button>
        </div>
    );
};

export default ChatbotEntryPoint;
